import React from "react";
import DataGridCustomToolbar from "components/DataGridCustomToolBar";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useUserGrid } from "./hooks/useUserGrid";

function UserGrid({ handleEditOpen }) {
  const {
    users,
    totalUsers,
    columns,
    page,
    setPage,
    pageSize,
    setPageSize,
    search,
    setSearch,
    searchInput,
    setSearchInput,
    sort,
    setSort,
    backgroundAlt,
    primaryLight,
    primaryDark,
    welcomeEmailDialogOpen,
    setWelcomeEmailDialogOpen,
    selectedUserEmail,
    selectedUserName,
    handleSendWelcomeEmail,
    passwordResetDialogOpen,
    setPasswordResetDialogOpen,
    handleSendPasswordReset,
  } = useUserGrid({ handleEditOpen });

  return (
    <Box
      mt="40px"
      sx={{
        "& .MuiDataGrid-root": {},
        "& .MuiDataGrid-cell": {
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "visible",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-footerContainer": {
          backgroundColor: primaryLight,
        },
        "& .MuiDataGrid-row": {
          height: "auto", // This ensures the row height adapts to content
        },
      }}
    >
      <DataGridPro
        getRowId={(row) => row._id}
        rows={users}
        columns={columns}
        rowCount={totalUsers}
        pagination
        paginationMode="server"
        // ✅ controlled pagination model (0-based)
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={({ page, pageSize }) => {
          setPage(page); // keep 0-based
          setPageSize(pageSize);
        }}
        loading={users.length === 0}
        slots={{ toolbar: DataGridCustomToolbar }}
        slotProps={{
          toolbar: {
            search,
            setSearch,
            searchInput,
            setSearchInput,
            sort,
            setSort,
            backgroundAlt,
            primaryLight,
            primaryDark,
          },
        }}
      />

      <Dialog
        open={passwordResetDialogOpen}
        onClose={() => setPasswordResetDialogOpen(false)}
      >
        <DialogTitle>Confirm Password Reset</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to send a password reset email to{" "}
            {selectedUserName} - <strong>{selectedUserEmail}</strong>?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPasswordResetDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleSendPasswordReset}
            variant="contained"
            color="primary"
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={welcomeEmailDialogOpen}
        onClose={() => setWelcomeEmailDialogOpen(false)}
      >
        <DialogTitle>Confirm Welcome Email</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to send a welcome email to {selectedUserName}{" "}
            - <strong>{selectedUserEmail}</strong>?
            <br />
            <br />
            <Typography variant="body2" color="textSecondary">
              Note: This will send a welcome email to the user, including
              instructions on how to log in for the first time. If the user has
              already set a password, this will overwrite it.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWelcomeEmailDialogOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleSendWelcomeEmail}
            variant="contained"
            color="primary"
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UserGrid;
